/**
 * Scroll top button
 */
function scrollToTop() {
  // cancel if already on top
  if (document.scrollingElement.scrollTop === 0) return;

  const duration = 100;

  const cosParameter = document.scrollingElement.scrollTop / 2;
  let scrollCount = 0;
  let oldTimestamp = null;

  /**
   * @param {number} newTimestamp
   * @return {number}
   */
  function step(newTimestamp) {
    if (oldTimestamp !== null) {
      // if duration is 0 scrollCount will be Infinity
      scrollCount += (Math.PI * (newTimestamp - oldTimestamp)) / duration;

      if (scrollCount >= Math.PI) {
        return (document.scrollingElement.scrollTop = 0);
      }

      document.scrollingElement.scrollTop =
        cosParameter + cosParameter * Math.cos(scrollCount);
    }

    oldTimestamp = newTimestamp;
    window.requestAnimationFrame(step);
  }

  window.requestAnimationFrame(step);
}

export default () => {
  const btnTop = document.getElementById('js-btn-up');

  if (btnTop) {
    btnTop.addEventListener('click', scrollToTop);
  }
};
